import styled from '@emotion/styled';
import {Chip, RadioButton} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;

export const SelectButton = styled(RadioButton)`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 12rem;
  padding-bottom: 0.5rem;
`;

export const TooltipDiv = styled.div`
  display: block;
  font-size: 11px;
  white-space: pre-line;
`;
